<template>
  <div class="register-page">

    <div class="form-container">
      <div class="form-content">
        <div class="form-item">
          <input placeholder="请输入手机号" v-model="data.phone" type="tel" maxlength="11">
        </div>
        <div class="form-item sms">
          <input placeholder="请输入验证码" v-model="data.code" type="tel" maxlength="4">
          <button @click="getSms" v-if="showCode">获取验证码</button>
          <button v-else>{{counts}}s重新发送</button>
        </div>
        <div class="btn" @click="login">
          获取案源
        </div>

        <div class="protocol">
          <van-checkbox checked-color="#999999" v-model="checked" icon-size="13px"></van-checkbox>
          <p>阅读并同意 <a href="https://protocol.imlaw.cn/lawyer_user_protocol.html?header=0">《法临注册协议》</a></p>
        </div>
      </div>
    </div>
    <div class="pictures">
      <img src="@/assets/imgs/invitationPage/Slice1@2x.png" alt="">
      <img src="@/assets/imgs/invitationPage/Slice2@2x.png" alt="">
    </div>
    <div class="fixed-btn">
      <div class="btn btn1" @click="toWeChatAppletBtn">
        <img src="@/assets/imgs/registerThree/wechat.png" class="icon" alt="" srcset="">
        微信合作
      </div>
      <div class="btn btn2" @click="scrollToTop">
        <img src="@/assets/imgs/registerThree/dowload.png" class="icon" alt="" srcset="">
        获取案源
      </div>
    </div>
    <!-- 返回拦截弹窗 -->
    <van-popup
    v-model="weixinPopup"
    class="weixin-wrap"
    :close-on-click-overlay="false"
    round
    >
      <div class="content">
        <img src="@/assets/imgs/registerThree/close.png" alt="" class="close" @click="closeWeChatPopup">
        <p class="desc">全国10000+当事人咨询中</p>
        <p class="more"><span>添加客服微信</span>了解更多</p>
        <img src="@/assets/imgs/registerThree/cases.png" alt="" class="cases">
        <img src="@/assets/imgs/registerThree/btn.webp" alt="" class="btn" @click="toWeChatApplet">
      </div>
    </van-popup>
  </div>
</template>

<script>
import {sendCode} from "@a";
import {login} from "@a/activity";
import {lawyerChannelBuryPv,urlSchemeGenerate} from "@a/invitation";
import {BEHAVIOR, BURY_POINT_TYPE, POINT_CODE} from "@/libs/config.js";
import {buriedChannelPoint} from "@a/common.js";
export default {
  name: "register",
  data(){
    return{
      counts:60,
      showCode:true,
      checked:true,
      timerInterval:'',
      data:{
        phone:'',
        code:''
      },
      weixinPopup: false,//微信客服弹窗
    }
  },
  mounted() {
    let params = {
      code: POINT_CODE.LAW_PAGE_H5_INVITE_PAGE,
      type: BURY_POINT_TYPE.PAGE,
      behavior: BEHAVIOR.VI,
    };
    buriedChannelPoint(params);
    lawyerChannelBuryPv({
      channelId:this.$route.query.lawyerChannel
    })
    this.addListenerBack()
  },
  methods:{
    // 跳转微信 客服页面
    wxURLScheme(){
      const URLScheme = localStorage.getItem('URLScheme_2')
      if(URLScheme){
        window.location.href = URLScheme
        return false
      }
      urlSchemeGenerate({
        // path:'pages/index/index',
        path:'pages/toutiao-download/customer/index',
        query: null
      }).then(({data})=>{
        localStorage.setItem('URLScheme_2',data)
        window.location.href = data
      })
    },
    // 弹窗中去微信小程序
    toWeChatApplet(){
      let params = {
        code: POINT_CODE.LAW_GUIDE_SERVICE_WINDOW_CLICK,
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);
      this.wxURLScheme()
    },
    // 点击微信合作埋点
    toWeChatAppletBtn(){
      let params = {
        code: POINT_CODE.LAW_GUIDE_WECHAT_JOIN_CLICK,
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);
      this.wxURLScheme()
    },
    // 关闭弹窗
    closeWeChatPopup(){
      let params = {
        code: POINT_CODE.LAW_GUIDE_SERVICE_WINDOW_CLOSE_CLICK,
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);
      this.weixinPopup = false
    },
  // 底部获取案源埋点
    scrollToTop(){
      let params = {
        code: POINT_CODE.LAW_GUIDE_BOTTOM_GET_CASE_CLICK,
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);

      window.scrollTo({
        top:60,
        left:0,
        behavior:'smooth'
      })
    },


    /* 添加返回监听*/
    addListenerBack() {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.backFn)
      this.$on('hook:destroyed', () => {
        window.removeEventListener('popstate', this.backFn)
      })
    },
    backFn() {
      this.weixinPopup = true
      let params = {
        code: POINT_CODE.LAW_GUIDE_ADD_SERVICE_WINDOW,
        type: BURY_POINT_TYPE.PAGE,
        behavior: BEHAVIOR.VI,
      };
      buriedChannelPoint(params);

    },
    login(){
      let message = !this.data.phone && '请输入手机号！' ||
          !/^1\d{10}/.test(this.data.phone) && '输入手机号有误' ||
          !this.data.code && '请输入验证码！' ||
          !/\d{4}/.test(this.data.code) && '输入验证码有误' || null ||
          !this.checked && '请阅读并勾选《法临注册协议》' || null;
      if (message) return this.$toast(message);
      /**
       * inviteSource 3、律师端分享(inviteId) 2、营销人员分享(inviteSysUserId)
       */
      const inviteInfo={
        inviteId: this.$route.query.inviteId || this.$route.query.inviteSysUserId,  //分享id
        inviteSource:this.$route.query.inviteId ? 3:2
      }
      let params = {
        code: POINT_CODE.LAW_PAGE_H5_USER_GET_CASE_BUTTON_CLICK,
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK,
      };
      buriedChannelPoint(params);
      login({
        ...this.data,
        ...inviteInfo,
        lawyerChannel:this.$route.query.lawyerChannel
      },{
        headers:{
          osVersion:9
        }
      }).then(()=>{
        this.$router.push({
          path:'/invitation-page/registerSuccessThree'
        })
      }).catch(({data})=>{
        if(data.code===1){
          setTimeout(()=>{
            this.$router.push({
              path:'/invitation-page/registerSuccessThree'
            })
          },2000)
        }
      })
    },
    getSms(){
      let message = !this.data.phone && '请输入手机号！' ||
          !/^1\d{10}/.test(this.data.phone) && '输入手机号有误' || null
      if (message) return this.$toast(message)
      sendCode({phone: this.data.phone}).then(res => {
        if (!res.code) {
          this.$toast('发送成功')
          this.timer()
        }
      })
    },
    /* 倒计时*/
    timer() {
      if (!this.timerInterval) {
        this.counts = this.$options.data().counts
        this.showCode = false
        this.timerInterval = setInterval(() => {
          if (this.counts > 0) {
            this.counts--
          } else {
            this.clearTimer();
          }
        }, 1000)
      }
      this.$on('hook:destroyed', () => {
        this.clearTimer();
      })
    },
    clearTimer() {
      this.showCode = true
      clearInterval(this.timerInterval)
      this.timerInterval = null
    },
  }
}
</script>

<style scoped lang="scss">
.register-page{
  min-height: 1746px;
  padding-bottom: 20px;
  .register-header{
    padding-top: 73px;
    img{
      display: block;
      margin: 0 auto;
      width: 316px;
      height: 94px;
    }
    box-sizing: border-box;
    height: 357px;
  }
  .form-container{
    background: url("~@/assets/imgs/invitationPage/Frame2455@2x.png") no-repeat;
    background-size: 100% 100%;
    height: 784px;
    padding-top: 482px;
    box-sizing: border-box;
    .form-content{
      box-sizing: border-box;
      width: 350px;
      padding: 17px 17px 33px;
      background: white;
      margin: 0 auto;
      box-shadow: 0px 5px 25px 0px rgba(133,3,0,1);
      border-radius: 13px 13px 13px 13px;
      .form-item{
        height: 45px;
        border: 1px solid #BFBFBF;
        border-radius: 22px;
        overflow: hidden;
        input{
          outline: none;
          text-indent: 27px;
          border: none;
          height: 100%;
          width: 100%;
          font-size: 15px;
          font-weight: 400;
        }
      }
      .sms{
        display: flex;
        margin-top: 17px;
        justify-content: space-between;
        align-items: center;
        padding-right: 9px;
        input{
          // width: auto;
          flex: 1;
        }
        button{
          width: 96px;
          border: none;
          font-weight: 400;
          background: none;
          outline: none;
          position: relative;
          background: rgba(222,93,59,0.1);
          border-radius: 24px 24px 24px 24px;
          height: 34px;
          font-size: 13px;
          color: #DE5D3B;
        }
      }

      .protocol{
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 17px;
        p{
          padding-left: 4px;
          font-size: 13px;
          font-weight: normal;
          color: #999999;
          a{
            color: #999999;
            text-decoration: underline;
          }
        }
      }

      .btn{
        display: flex;
        align-items: center;
        margin-top: 17px;
        justify-content: center;
        width: 324px;
        height: 45px;
        background: linear-gradient(90deg, #FA700D 0%, #F34747 100%);
        border-radius: 22px;
        font-size: 17px;
        color: #FFFFFF;
        font-weight: 500;
      }
    }
  }
  .pictures{
    img{
      display: block;
      width: 100%;
    }
  }
  .fixed-btn{
    width: 375px;
    height: 70px;
    background: #FFFFFF;
    box-shadow: 0px -3px 10px 0px rgba(0,0,0,0.08);
    border-radius: 16px 16px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 17px 10px 17px;
    position: fixed;
    bottom: 0;
    box-sizing: border-box;
    .btn{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 44px;
      border-radius: 68px 68px 68px 68px;
      width: 165px;
      .icon{
        margin-right: 4px;
        width: 25px;
        height: 25px;
      }
    }
    .btn1{
      background: #E6F9EF;
      color: #07C160;
      font-size: 15px;
      position: relative;
      .openweapp{
        width: 100%;
        height: 100%;
        background: transparent;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    .btn2{
      background: linear-gradient(90deg, #FA700D 0%, #F34747 100%);
      color: #fff;
      font-size: 17px;
    }
  }
  .weixin-wrap{
    width: 324px;
    height: 401px;
    .content{
      width: 324px;
      height: 401px;
      background: url('~@/assets/imgs/registerThree/bg@2x.png') no-repeat;
      background-size: 100% 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 42px;
      box-sizing: border-box;
      .close{
        position: absolute;
        width: 25px;
        height: 25px;
        top: 14px;
        right: 14px;
      }
      .desc{
        font-size: 14px;
        color: #999999;
        margin-bottom: 4px;
      }
      .more{
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000;
        span{
          color: #F24A47;
        }
      }
      .cases{
        width: 264px;
        height: 194px;
        margin: 17px 0 25px 0;
      }
      .btn{
        width: 264px;
        height: 59px;
      }
    }
  }
}
</style>
